import { t } from 'i18next';
import styles from '../EmployerPortalJobs/EmployerPortalJobs.module.css';
import BubbleButton from '../../Buttons/BubbleButton/BubbleButton';
import candidatesStyles from './EmployerPortalCandidates.module.css';
import FormSelectField from '../../UpdatedFormUI/FormSelectField/FormSelectField';
import { SortIconList } from '../../../../assets/images/icons';
import FormField from '../../UpdatedFormUI/FormField/FormField';
import Select, { components } from 'react-select';
import CloseIcon from '../../../../assets/images/icons/close.svg';

export const filterUI = (formik, activeButton, setActiveButton, getNumberOfJobs, categoryOptions, citiesOptions, listOptions, handleFindCandidates, removeList, isCandidates, candidateData, sortBy, setSortBy, showSortDropdown, setShowSortDropdown,jobTitleDropdown) => {
    // Sort options
    const sortOptions = [
        { value: 'newest', label: t("jobs.newest") },
        { value: 'oldest', label: t("jobs.oldest") }
    ];

    const handleSortChange = (selectedOption) => {
        if (setSortBy) {
            setSortBy(selectedOption.value);
        }
    };
    
    const FILTERBUTTONS = [
        t("candidatesFilterUI.all"),
        t("candidatesFilterUI.new"),
        t("candidatesFilterUI.shortlisted"),
        t("candidatesFilterUI.undecided"),
        t("candidatesFilterUI.rejected"),
    ];
    const salaryOptions = [
        { value: `0-100`, label: "$1 - $100" },
        { value: `100-500`, label: "$100 - $500" },
        { value: `500-1000`, label: "$500 - $1k" },
        { value: `1000-2000`, label: "$1K - $2K" },
        { value: `2000-5000`, label: "$2K - $5K" },
        { value: `5000-10000`, label: "$5K - $10K" },
        { value: `10000-20000`, label: "$10K - $20K" },
    ];
    const genderOptions = [
        { value: 'male', label: t('forms.welcome_job_seeker.step_1.male') },
        { value: 'female', label: t('forms.welcome_job_seeker.step_1.female') }
    ];

    const handleSkillsChange = (value) => { formik.setFieldValue('skills', value); };
    
    const handleTitleChange = (selectedOptions) => {
        formik.setFieldValue('title', selectedOptions);
    };

    // Function to clear individual filter
    const handleClearFilter = (fieldName) => {
        if (Array.isArray(formik.values[fieldName])) {
            formik.setFieldValue(fieldName, []);
        } else {
            formik.setFieldValue(fieldName, '');
        }
    };

    // Custom FormSelectField wrapper component with clear button
    const FilterSelectField = ({ name, ...props }) => {
        const hasValue = Array.isArray(formik.values[name]) 
            ? formik.values[name].length > 0 
            : formik.values[name] !== '' && formik.values[name] !== null && formik.values[name] !== undefined;
        
        return (
            <div className={candidatesStyles.filterSelectWrapper}>
                <FormSelectField
                    name={name}
                    {...props}
                />
                {hasValue && (
                    <div 
                        className={candidatesStyles.clearFilterButton}
                        onClick={() => handleClearFilter(name)}
                    >
                        <img src={CloseIcon} alt="Clear" />
                    </div>
                )}
            </div>
        );
    };

    // Check if any formik value has data
    const hasFilters = Object.values(formik.values).some(value => {
        if (Array.isArray(value)) {
            return value.length > 0; // Check if array is not empty
        }
        return value !== '' && value !== null && value !== undefined;
    });
    // Function to reset form values
    const handleResetFilters = () => {
        formik.resetForm();
    };

    // Custom component for the dropdown value display
    const CustomValueContainer = ({ children, ...props }) => {
        return (
            <components.ValueContainer {...props}>
                <div style={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    height: '100%'
                }}>
                    <img src={SortIconList} alt="Sort Icon" style={{ marginRight: '8px', flexShrink: 0 }} />
                    <span style={{ 
                        fontSize: "16px", 
                        color: "#093559", 
                        flexShrink: 0,
                        marginRight: '4px'
                    }}>{t("sortBy")}</span>
                    <div style={{ 
                        minWidth: 0, 
                        overflow: 'hidden', 
                        textOverflow: 'ellipsis',
                        display: 'flex',
                        alignItems: 'center',
                        height: '100%'
                    }}>
                        {children}
                    </div>
                </div>
            </components.ValueContainer>
        );
    };
    
    // Custom component for the single value
    const CustomSingleValue = (props) => {
        return (
            <components.SingleValue {...props}>
                <div style={{ 
                    display: 'flex',
                    alignItems: 'center',
                    height: '100%'
                }}>
                    {props.children}
                </div>
            </components.SingleValue>
        );
    };
    
    // This will style the dropdown to match your UI
    const customSelectStyles = {
        control: (provided, state) => ({
            ...provided,
            borderColor: '#8A8A8E',
            borderWidth: '1px',
            borderRadius: '10px',
            height: '44px',
            cursor: 'pointer',
            boxShadow: 'none',
            display: 'flex',
            alignItems: 'center',
            '&:hover': {
                borderColor: '#0364b2'
            }
        }),
        valueContainer: (provided) => ({
            ...provided,
            padding: '0 8px',
            overflow: 'visible',
            whiteSpace: 'nowrap',
            height: '100%',
            display: 'flex',
            alignItems: 'center'
        }),
        option: (provided, { isSelected }) => ({
            ...provided,
            backgroundColor: isSelected ? 'rgba(3, 100, 178, 0.05)' : 'white',
            color: isSelected ? '#0364b2' : '#4A4A4A',
            fontWeight: 500,
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            height: '40px',
            '&:hover': {
                backgroundColor: 'rgba(3, 100, 178, 0.05)',
                color: '#0364b2'
            }
        }),
        indicatorSeparator: () => ({
            display: 'none'
        }),
        dropdownIndicator: (provided, state) => ({
            ...provided,
            color: '#093559',
            transition: 'all 0.3s ease',
            transform: state.selectProps.menuIsOpen ? 'rotate(180deg)' : 'rotate(0deg)',
            padding: '0 8px',
            height: '100%',
            display: 'flex',
            alignItems: 'center'
        }),
        singleValue: (provided) => ({
            ...provided,
            color: '#093559',
            margin: '0',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            paddingTop: 0,
            paddingBottom: 0
        }),
        input: (provided) => ({
            ...provided,
            margin: '0',
            padding: '0',
            height: '100%'
        }),
        placeholder: (provided) => ({
            ...provided,
            margin: '0',
            display: 'flex',
            alignItems: 'center'
        }),
        multiValue: (provided) => ({
            ...provided,
            backgroundColor: 'rgba(3, 100, 178, 0.1)',
            borderRadius: '4px',
            margin: '2px'
        }),
        multiValueLabel: (provided) => ({
            ...provided,
            color: '#0364b2',
            fontWeight: 500,
            padding: '2px 4px'
        }),
        multiValueRemove: (provided) => ({
            ...provided,
            color: '#0364b2',
            ':hover': {
                backgroundColor: 'rgba(3, 100, 178, 0.2)',
                color: '#0364b2'
            }
        })
    };

    return (
        <div className={styles.container}>
            <div className={styles.row}>
                <p className={styles.heading}>{jobTitleDropdown?t("profileSidebar.tabs.applications"):t("candidatesFilterUI.candidates")}</p>
                {!isCandidates && (
                    <BubbleButton
                        dark
                        headerDarkButton
                        to={'/employer-portal/candidates'}
                        style={{ padding: '10px 20px' }}
                        onClick={handleFindCandidates}
                    >
                        {t("candidatesFilterUI.find_candidates")}
                    </BubbleButton>
                )}
            </div>
            <div className={` ${candidatesStyles.filterWrapper} ${styles.wrape}`}>
                <div className={candidatesStyles.dropdownContainer}>
                  {jobTitleDropdown?
                    <FilterSelectField
                    name="title"
                    type="default"
                    placeholder={t('searchPlaceholderJobTitle')}
                    hasBorder
                    themeLight
                    options={categoryOptions}
                    onChange={handleTitleChange}
                    value={formik.values.title}
                    error={formik.touched.title && formik.errors.title}
                    isMulti={true}
                    />
                    :
                    <div className={candidatesStyles.filterSelectWrapper}>
                        <FormField
                            name="title"
                            type="text"
                            placeholder={t('searchPlaceholderJobTitle')}
                            hasBorder
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            filter
                            value={formik.values.title}
                            error={formik.touched.title && formik.errors.title}
                        />
                        {formik.values.title && (
                            <div 
                                className={candidatesStyles.clearFilterButton}
                                onClick={() => handleClearFilter('title')}
                            >
                                <img src={CloseIcon} alt="Clear" />
                            </div>
                        )}
                    </div>
                    }
                </div>
                <div className={candidatesStyles.dropdownContainer}>
                    <FilterSelectField
                        name="country"
                        type="country"
                        placeholder={t("candidatesFilterUI.select_country")}
                        hasBorder
                        onFormikChange={formik.handleChange}
                        themeLight
                        value={formik.values.country}
                        error={formik.touched.country && formik.errors.country}
                    />
                </div>
                {citiesOptions?.length > 0 && (
                    <div className={candidatesStyles.dropdownContainer}>
                        <FilterSelectField
                            name="city"
                            type="default"
                            placeholder={t("candidatesFilterUI.select_city")}
                            hasBorder
                            themeLight
                            options={citiesOptions}
                            onBlur={formik.handleBlur}
                            onFormikChange={formik.handleChange}
                            value={formik.values.city}
                            error={formik.touched.city && formik.errors.city}
                        />
                    </div>
                )}
                {removeList ? <></> :
                    <div className={candidatesStyles.dropdownContainer}>
                        <FilterSelectField
                            name="list"
                            placeholder={t("candidatesFilterUI.select_list")}
                            type="default"
                            hasBorder
                            themeLight
                            options={listOptions}
                            onFormikChange={formik.handleChange}
                            value={formik.values.list}
                            error={formik.touched.list && formik.errors.list}
                        />
                    </div>
                }
                {isCandidates &&
                    <>
                        <div className={candidatesStyles.dropdownContainer}>
                            <FilterSelectField
                                name="nationality"
                                themeLight
                                type="nationality"
                                placeholder={t('forms.welcome_employer.nationality')}
                                onFormikChange={formik.handleChange}
                                value={formik.values.nationality}
                                error={formik.touched.nationality && formik.errors.nationality}
                            />
                        </div>
                        {candidateData?.educationLevels &&
                            <div className={candidatesStyles.dropdownContainer}>
                                <FilterSelectField
                                    name="education_level"
                                    type="default"
                                    placeholder={t('forms.education.education_level')}
                                    themeLight
                                    hasBorder
                                    options={candidateData?.educationLevels}
                                    onFormikChange={formik.handleChange}
                                    value={formik.values.education_level}
                                    error={formik.touched.education_level && formik.errors.education_level}
                                />
                            </div>
                        }
                        <div className={candidatesStyles.dropdownContainer}>
                            <FilterSelectField
                                name="language"
                                type="language"
                                placeholder={t('forms.language.select_language')}
                                themeLight
                                hasBorder
                                onFormikChange={formik.handleChange}
                                value={formik.values.language}
                                error={formik.touched.language && formik.errors.language}
                            />
                        </div>
                        {candidateData?.options &&
                            <div className={candidatesStyles.dropdownContainer}>
                                <FilterSelectField
                                    themeLight
                                    name="skills"
                                    type="default"
                                    placeholder={t('job_seeker.skills')}
                                    hasBorder
                                    options={candidateData?.options}
                                    onChange={handleSkillsChange}
                                    value={formik.values.skills}
                                    error={formik.touched.skills && formik.errors.skills}
                                />
                            </div>
                        }

                        <div className={candidatesStyles.dropdownContainer}>
                            <FilterSelectField
                                name="gender"
                                themeLight
                                type="default"
                                placeholder={t('forms.welcome_job_seeker.step_1.gender')}
                                options={genderOptions}
                                onFormikChange={formik.handleChange}
                                value={formik.values.gender}
                                error={formik.touched.gender && formik.errors.gender}
                            />
                        </div>
                        <div className={candidatesStyles.dropdownContainer}>
                            <FilterSelectField
                                themeLight
                                name="salary_range"
                                type="default"
                                placeholder={t(`talents_list.salary_range`)}
                                hasBorder
                                options={salaryOptions}
                                value={formik.values.salary_range}
                                onFormikChange={formik.handleChange}
                                error={formik.touched.salary_range && formik.errors.salary_range}
                            />
                        </div>
                        <div className={candidatesStyles.dropdownContainer}>
                            <FilterSelectField
                                themeLight
                                name="yearOfExp"
                                type="default"
                                placeholder={t('TalentCard.years_of_experience')}
                                hasBorder
                                options={[
                                    { value: `0-1`, label: `0-1 ${t('general.UI.year')}` },
                                    { value: `1-5`, label: `1-5 ${t('general.UI.year')}` },
                                    { value: `5-10`, label: `5-10 ${t('general.UI.year')}` },
                                    { value: `10-20`, label: `10-20 ${t('general.UI.year')}` },
                                    { value: `20-50`, label: `20-50 ${t('general.UI.year')}` },
                                ]}
                                value={formik.values.yearOfExp}
                                onFormikChange={formik.handleChange}
                                error={formik.touched.yearOfExp && formik.errors.yearOfExp}
                            />
                        </div>
                        <div className={candidatesStyles.dropdownContainer}>
                            {hasFilters && (
                                <BubbleButton
                                    dark
                                    headerDarkButton
                                    style={{ padding: '7px 10px', }}
                                    onClick={handleResetFilters}
                                >
                                    {t("candidatesFilterUI.remove_all_filters")}
                                </BubbleButton>
                            )}
                            {isCandidates && (
                                <BubbleButton
                                    dark
                                    headerDarkButton
                                    style={{ padding: '7px 10px', marginLeft: '10px' }}
                                    onClick={handleFindCandidates}
                                >
                                    {t("talents.search")}
                                </BubbleButton>
                            )}
                        </div>
                    </>
                }
            </div>

            {isCandidates ? <></> :
                <div className={`${styles.filterContainer} ${styles.wrape}`}>
                    <div className={`${styles.buttonFilterContainer} ${candidatesStyles.buttonFilterContainerCandidates}`}>
                        {FILTERBUTTONS.map((item, index) => {
                            return (
                                <div
                                    key={index.toString()}
                                    className={styles.buttonWrapper}
                                    onClick={() => { setActiveButton(item) }}
                                >
                                    <div className={activeButton === item ? styles.activeButtonTitle : styles.buttonTitle}
                                        style={{ fontSize: "16px" }}
                                    >
                                        {/* {item} ({'\u200E'}{getNumberOfJobs(index)}) */}
                                        {item} {getNumberOfJobs(index)}

                                    </div>
                                    {index < FILTERBUTTONS.length - 1 && <div className={`${styles.saperator} ${candidatesStyles.saperator}`}></div>}
                                </div>
                            );
                        })}
                    </div>
                    <div className={`${styles.filterTitleWrapper} ${styles.height44} ${candidatesStyles.sortWrapper}`}>
                        <div style={{ width: '240px' }}>
                            <Select
                                options={sortOptions}
                                value={sortOptions.find(option => option.value === (sortBy ||t("jobs.newest")))}
                                onChange={handleSortChange}
                                components={{ 
                                    ValueContainer: CustomValueContainer,
                                    SingleValue: CustomSingleValue
                                }}
                                styles={customSelectStyles}
                                isSearchable={false}
                            />
                        </div>
                    </div>
                </div>
            }
        </div>
    );
};